import type { GenePanelConfigurationId } from '../gene-panels';

// Minimum diluted DNA volume (µL) required for each SmartChip layout
const minimumByConfiguration: Record<GenePanelConfigurationId, number> = {
  '6:256': 30,
  '12:128': 30,
  '24:72': 30,
  '36:48': 35,
  '48:36': 35,
  '54:32': 35,
  '72:24': 40,
  '80:21': 40,
  '96:18': 45,
  '120:14': 50,
  '144:12': 50,
  '216:8': 100,
  '248:6': 100,
  '296:5': 100,
  '384:4': 100,
};

// Absolute minimum diluted DNA volume (µL) required for analysis per assay count.
// Values are sourced from the lab table "Actual volume of sample required".
const absoluteMinimumByAssays: Partial<Record<number, number>> = {
  // Note: the "Samples and assay volumes required for different layouts" sheet does not include a 6-assay row.
  // Until we have authoritative data, reuse the 12-assay (14.1 µL) value as a conservative absolute minimum.
  6: 14.1,
  12: 14.1,
  24: 15.0,
  36: 15.6,
  48: 16.8,
  54: 17.4,
  72: 18.6,
  80: 19.2,
  96: 20.4,
  120: 22.8,
  144: 24.3,
  216: 43.2,
  248: 46.8,
  296: 76.8,
  384: 86.4,
};

export function getMinimumDilutedDnaVolume(configurationId: GenePanelConfigurationId): number {
  return minimumByConfiguration[configurationId];
}

export function getAbsoluteMinimumDilutedDnaVolume(configurationId: GenePanelConfigurationId): number {
  const genesPart = configurationId.split(':')[0];
  const assays = Number(genesPart);
  const absolute = absoluteMinimumByAssays[assays];
  if (typeof absolute === 'number' && Number.isFinite(absolute)) {
    return absolute;
  }
  // Fallback: if we don't have a lab-derived absolute minimum, keep the customer minimum.
  return getMinimumDilutedDnaVolume(configurationId);
}
